export default {
      id: "arrow-usage",
      viewBox: "0 0 10 5",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }